import { Fun } from 'widgets-for-react'

import { CtaBlockStyle } from '../../cms/blocks/widgets/ctaBlock.gen'
import { FeaturedContentBlockStyle } from '../../cms/blocks/widgets/featuredContentBlock.gen'
import { LinkBlockStyle } from './custom_blocks/widgets/linkBlock.mod'
import { LinkGridBlockStyle } from '../../cms/blocks/widgets/linkGridBlock.gen'
import { TextBlockStyle } from '../../cms/blocks/widgets/textBlock.gen'
import { ExpandBlockStyle } from '../../cms/blocks/widgets/expandBlock.gen'
import { MediaBlockStyle } from './custom_blocks/widgets/mediaBlock.mod'
import { IframeBlockStyle } from './custom_blocks/widgets/iframeBlock.mod'
import { RekenToolBlockStyle } from './custom_blocks/widgets/rekentoolBlock.mod'
import { QuoteBlockStyle } from './custom_blocks/widgets/quoteBlock.mod'
import { HeroBlockStyle } from './custom_blocks/widgets/heroBlock.mod'
import { FormBlockStyle } from './custom_blocks/widgets/formBlock.mod'
import { DownloadsBlockStyle } from './custom_blocks/widgets/downloadsBlock'
import { PageNavigationBlockStyle } from './custom_blocks/widgets/pageNavigation'

export const featuredContentClasses: Fun<'left' | 'right', FeaturedContentBlockStyle> = m => ({})

export const heroBlockClasses:HeroBlockStyle = {
    block_classname: 'aa',
    inner_classname: 'bb',
    header_classname: 'cc',
    title_classname: 'dd',
    content_classname: 'ee',
    intro_classname: 'ff',
    visual_classname: 'gg'
}

export const textBlockClasses:TextBlockStyle = {
    block_classname: 'block block--text',
    inner_classname: 'block__inner container container--m grid--block',
    clickable_primary_classname: 'btn btn--primary',
    clickable_secondary_classname: 'btn btn--secondary',
    header_classname: 'block__header',
    content_classname: 'block__content',
    footer_classname: 'block__footer btn__wrapper',
    text_classname: 'block__text text--styled',
    title_classname: 'block__title typo--l'
}

export const ctaBlockClasses: CtaBlockStyle = {
    block_classname: 'block block--cta container container--l grid--block',
    inner_classname: 'block__inner',
    header_classname: 'block__header',
    title_classname: 'block__title',
    content_classname: 'block__content text--styled',
    text_classname: 'block__text text--styled',
    footer_classname: 'block__footer btn__wrapper',
    clickable_primary_classname: 'btn btn--primary btn--primary--next',
    clickable_secondary_classname: 'btn btn--secondary'
}

export const linkListBlockClasses: LinkBlockStyle = {
    block_classname: 'block block--link-list block--columns',
    inner_classname: 'block__inner b--vc container container--l grid--block',
    header_classname: 'block__header item--2',
    title_classname: 'block__title typo--l',
    intro_classname: 'block__intro text--styled',
    content_classname: 'block__content item--1',
    list_classname: 'list',
    item_classname: 'list__item',
    item_label_classname:'item__label typo--s',
    item_icon_classname: 'item__icon',
    link_classname: 'list-item__link item__link'
}

export const downloadBlockClasses: DownloadsBlockStyle = {
    block_classname: 'block block--download block--columns',
    inner_classname: 'block__inner b--vc container container--l grid--block ',
    header_classname: 'block__header item--2',
    title_classname: 'block__title typo--l',
    intro_classname: 'block__intro text--styled',
    content_classname: 'block__content item--1',
    list_classname: 'list',
    item_classname: 'list__item',
    item_label_classname: 'item__label typo--s',
    item_icon_classname: 'item__icon',
    link_classname: 'item__link'
}

export const formBlockClasses: FormBlockStyle = {
    block_classname: 'block block--form',
    inner_classname: 'block__inner container container--m grid--block',
    content_classname: 'block__content'
}

export const tableBlockClasses: FormBlockStyle = {
    block_classname: 'block block--table',
    inner_classname: 'block__inner container container--l grid--block',
    content_classname: 'table-outer'
}


export const linkGridBlockClasses: Fun<boolean, LinkGridBlockStyle> = hasbutton => ({})

export const expandBlockClasses: ExpandBlockStyle = {
    block_classname: 'block block--expand',
    inner_classname: 'block__inner b--vc container container--l grid--block',
    header_classname: 'block__header item--2',
    title_classname: 'block__title typo--l',
    intro_classname: 'block__intro text--styled',
    content_classname: 'block__content item--1',
    text_classname: 'block__text',
    footer_classname: 'block__footer item--3',
    clickable_classname: 'block__clickable btn btn--tertiary',
    list_classname: 'expand-list',
    expand_item_classname: 'expand-list__item expand',
    expand_button_classname: 'expand__button',
    expand_title_classname: 'expand__title',
    expand_icon_classname: 'expand__icon',
    expand_text_classname: 'expand__text text--styled'
}

export const mediaBlockClasses : MediaBlockStyle = {
    block_classname: `block block--media container container--m grid--block`,
    inner_classname: `block__inner`,
    content_classname: 'block__content',
    figure_classname: `block__visual`,
    media_classname: `block__image-wrapper`,
    image_classname: 'block__image',
    placeholder_classname: 'block__placeholder section__media-placeholder',
    video_classname: '',
    figcaption_classname: 'block__caption',
    caption_classname: '',
    cookies_classname: 'media__placeholder',
    cookies_inner_classname: 'media__inner',
    cookies_text_classname: 'text--styled',
    cookies_clickable_classname: 'btn btn--primary'
}

export const mediaNestedBlockClasses : MediaBlockStyle = {
  block_classname: `block block--media-nested`,
  figure_classname: `block__visual`,
  media_classname: `block__image-wrapper`,
  image_classname: 'block__image',
  placeholder_classname: 'block__placeholder section__media-placeholder',
  video_classname: '',
  figcaption_classname: 'block__caption',
  caption_classname: '',
  cookies_classname: 'media__placeholder',
  cookies_inner_classname: 'media__inner',
  cookies_text_classname: 'text--styled',
  cookies_clickable_classname: 'btn btn--primary'
}

export const linkGridBlockPlainClasses: Fun<number, LinkGridBlockStyle> = n => ({})

export const quoteBlockClasses : QuoteBlockStyle = {
    block_classname: 'block block--quote',
    inner_classname: 'block__inner container container--l grid--block',
    content_classname: 'block__content',
    text_classname: 'block__text',
    quote_classname: 'block__quote',
    visual_classname: 'block__visual',
    image_classname: 'block__image',
    author_classname: 'block__author typo--s',
    footer_classname: 'block__footer',
    clickable_classname: 'btn btn--primary'
}

export const iframeBlockClasses: IframeBlockStyle = {
    block_classname: 'block block--iframe',
    inner_classname: 'block__inner',
    content_classname: 'block__content',
    iframe_classname: 'block__iframe'
}

export const rekenToolBlockClasses: RekenToolBlockStyle = {
    block_classname: 'block block--rekentool',
    inner_classname: 'block__inner container container--s grid--block',
    content_classname: 'block__content',
    iframe_classname: 'block__iframe wbRekentool'
}

export const PageNavigationBlockClasses: PageNavigationBlockStyle = {
    block_classname: 'nav nav--page container container--l grid--gutter',
    inner_classname: 'block__inner',
    item_link_classname: 'nav__link typo--s',
    item_link_text_classname: 'nav__link-text',
    list_classname: 'nav__items',
    list_item_classname: 'nav__item',
    list_item_label_classname: 'nav__item nav__item-label',
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/style.mod.ts